import React from 'react';
import Select from 'react-select';


/**
 * Diet Switcher component
 */
const DietSwitcher = (props) => {
  let options = [];
  props.data.data[props.type].map((value, index) => {
    let disabled = false;
    if(props.selected.includes(index)){
      disabled = true;
    }
    options.push({value: index, label:value.label, isDisabled: disabled});
  });

  return(
    <div className="nppe2-fc-diet-switcher">
      <div className="nppe2-fc-sub-title">{props.data.label}</div>
      <Select
        options={options}
        className="nppe2-fc-react-select"
        name="nppe2-fc-diet-switcher-select"
        onChange={(selectedOption) => props.onSelect(selectedOption.value)}
        placeholder={props.data.dropdownLabel}
        value={false}
        aria-label={props.data.dropdownLabel}
        noOptionsMessage={() => props.data.noOptionsMsg}
      />
    </div>
  )
};


export default DietSwitcher;
